import type { SVGProps } from 'react';

const SvgCloseSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.5118 6.17857L14.0976 4.76436L10.1381 8.72392L6.17851 4.76436L4.76429 6.17857L8.72385 10.1381L4.76429 14.0977L6.17851 15.5119L10.1381 11.5523L14.0976 15.5119L15.5118 14.0977L11.5523 10.1381L15.5118 6.17857Z" />
  </svg>
);
export default SvgCloseSmall;
